import { initialAccountContactFormData } from 'components/accountContact/constants'
import { AccountRepFormData } from './types'

export const initialAccountRepFormData: AccountRepFormData = {
  ...initialAccountContactFormData,
  emailAddress: '',
}
